<template>
  <v-container>
    <div>
      <v-card-title
        class="titulo text-h4 mb-4"
      >
       <v-icon class="mr-2 align-items-center">fas fa-box</v-icon>{{item.id>-1?'Actualizar Bodega':'Crear Bodega'}}
      </v-card-title>
      <ValidationObserver v-slot="{handleSubmit}">
        <v-form @submit.prevent="handleSubmit(save)">
          <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
            <v-text-field
            label='Nombre'
            prepend-icon="mdi-file-document"
            v-model='item.name'
            outlined
            :error-messages="errors"
            :loading="loading"
            ></v-text-field>
            <v-checkbox
              v-model="item.add_stock"
              label="¿Suma a inventario?"
              dense
              />
          </ValidationProvider>
            <div class="text-center">
              <v-btn type="submit" color="success" :loading="loading"><v-icon class="mr-2">fas fa-sd-card</v-icon>Guardar</v-btn>
            </div>
        </v-form>
      </ValidationObserver>
    </div>
  </v-container>
</template>
<script>
import {getStore,createStore,updateStore} from '@/api/stocks'
import notifications from '@/utils/notifications'
export default {
  name:'StoreCreateUpdate',
  props:['id'],
  data() {
    return {
      item:'',
      loading:false,
    }
  },
  methods:{
    async save(){
      this.loading=true
      if(this.id>-1){
        await updateStore(this.id,{
          name:this.item.name,
          add_stock:this.item.add_stock
        })
        .then((res)=>{
          notifications.showSuccess('Bodega guardada correctamente')
          this.$emit('close')
          this.$emit('updated')
        })
        .catch(err=>{
          notifications.showError('Error actualizando Bodega '+err)
        })
        this.loading=false
      }
      else{
        await createStore({
          name:this.item.name,
          add_stock:this.item.add_stock
        })
        .then((res)=>{
          notifications.showSuccess('Bodega creada correctamente')
          this.$emit('close')
          this.$emit('updated')
        })
        .catch(err=>{
          notifications.showError('Error actualizando Bodega '+err)
        })
        this.loading=false
      }
      await this.$store.dispatch('getStores')
    },
    async get(){
      if(this.id>-1){
        this.loading=true
        await getStore(this.id)
        .then(res=>{
          this.item=res
        })
        .catch((err)=>{
          notifications.showError('Error cargando Bodega '+err)
        })
        this.loading=false
      }
      else{
        this.item={
          id:this.id,
          name:'',
        }
      }
    }
  },
  watch:{
    id:{
      handler:'get'
    }
  },
  created(){
    this.get()
  }

}
</script>

<style>

</style>